export { default } from "./useProductDetailsPage";
